import { useEffect } from "react";

// Inietta/aggiorna un unico tag <script type="application/ld+json"> in
// <head> — un solo blocco JSON-LD alla volta ha senso per una SPA (la
// pagina attiva è l'unica entità rilevante per i crawler in un dato
// momento).
export function useJsonLd(data) {
  useEffect(() => {
    if (!data) return;
    let el = document.head.querySelector("script#ld-json");
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = "ld-json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  }, [data]);
}
